import determineSize from '../dom/determineSize';

const setPrefix = (isUs, isEu, localSize) => {
  if(isUs) return ' US ' + localSize;
  if(isEu) return' EU ' + localSize;
  return ' UK ' + localSize
}

const formatSizeNames = (label, toSize: string, fromSize: string, withPrefix?: boolean): string => {
  const getSize = determineSize();
  const isEu = getSize === 'EU';
  const isUs = getSize === 'US';

  if(label.length && !isNaN(label) || label.length && label.includes(' - Sold Out')) {

    const sizeInt = parseInt(label) as any;
    let localSize = sizeInt;

    if(fromSize && fromSize !== null){

      // determined by switcher
      if (fromSize === 'uk') {
        if (toSize === 'eu') localSize = String(sizeInt + 28);
        if (toSize === 'us') localSize = String(sizeInt - 4);
      }
      if (fromSize === 'us') {
        if (toSize === 'eu') localSize = String(sizeInt + 32);
        if (toSize === 'uk') localSize = String(sizeInt + 4);
      }
      if (fromSize === 'eu') {
        if (toSize === 'uk') localSize = String(sizeInt - 28);
        if (toSize === 'us') localSize = String(sizeInt -32);
      }
    } else {
      // determined by markets
      if (isUs) localSize = String(sizeInt - 4);
      if (isEu) localSize = String(sizeInt + 28);
    }
      
    if(Number.isNaN(parseInt(localSize))) return label;

    if(withPrefix) localSize = setPrefix(isUs, isEu, localSize);
    if(label.includes(' - Sold Out')) localSize = localSize + ' - Sold Out';

    return localSize
  } else {
    return label
  }
};

export default formatSizeNames;